import React, {FC} from 'react';

import {TeammateModel} from '../../../../../../../libs/shared/core/src/models/api/teammateModel';
import {DataEventActionsEnum} from '../../../../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {ViewerDataEventObject} from '../../../../../../../libs/shared/core/src/models/tracking/objectNames/viewerDataEventObject';
import {useDataEventTracking} from '../../../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {useAppDispatch, useAppSelector} from '../../../../../../helpers/appReduxHelpers';
import {
  getHasAISummarizeFeature,
  getIsAiSummarizeEnabled,
} from '../../../../../../store/data/company/companySelectors';
import {manuallySummarizeConversationAsyncAction} from '../../../../../../store/data/conversations/conversationsActions';
import {ConversationHeaderAiSummarizeWrapper} from './conversationHeaderAiSummarizeWrapper';

/*
 * Props.
 */

interface ConversationHeaderAiSummarizeEmptyStateProps {
  conversationId: number;
  teammate: TeammateModel;
}

/*
 * Component.
 */

export const ConversationHeaderAiSummarizeEmptyState: FC<ConversationHeaderAiSummarizeEmptyStateProps> = ({
  conversationId,
  teammate,
}) => {
  const {trackDataEvent} = useDataEventTracking();
  const dispatch = useAppDispatch();
  const hasFeature = useAppSelector(getHasAISummarizeFeature);
  const isAiSummarizeEnabled = useAppSelector(getIsAiSummarizeEnabled);

  if (!hasFeature || !isAiSummarizeEnabled) {
    return null;
  }

  return (
    <ConversationHeaderAiSummarizeWrapper
      onKeyCommand={() => {
        trackDataEvent(DataEventActionsEnum.CLICK, ViewerDataEventObject.CONVERSATION_SUMMARY_GENERATE, {
          teammate_id: teammate.id,
          source: 'shortcut',
        });
        dispatch(manuallySummarizeConversationAsyncAction(conversationId));
      }}
      isButtonDisabled
      isButtonHidden
    >
      {null}
    </ConversationHeaderAiSummarizeWrapper>
  );
};
